<mat-card class="superadmin-registration">
  <mat-card-header>
    <div class="g-just-flex flex-between w-100">
      <div class="left">
        <mat-card-title>{{ formMeta.formName }}</mat-card-title>
        <mat-card-subtitle>{{ formMeta.formDescription }}</mat-card-subtitle>
      </div>
      <div class="right">
        <button mat-icon-button (click)="cancel()" matTooltip="Cancel">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content class="my-12">
    <mat-button-toggle-group
      class="account-type-toggle"
      [value]="accountType"
      (change)="onAccountTypeChange($event.value)">
      <mat-button-toggle value="SuperAdmin">
        <mat-icon>admin_panel_settings</mat-icon>
        Super Admin
      </mat-button-toggle>
      <mat-button-toggle value="EventManager">
        <mat-icon>event</mat-icon>
        Global Event Manager
      </mat-button-toggle>
    </mat-button-toggle-group>

    <div class="info-box">
      <mat-icon>info</mat-icon>
      <div class="info-content">
        @if (accountType === 'SuperAdmin') {
          <span><strong>Important:</strong> SuperAdmin users have full system access and are not associated with any organization. A temporary password will be automatically generated and sent to the email address provided.</span>
        } @else {
          <span><strong>Important:</strong> Global Event Managers can manage events across all organizations and are not tied to a single hospital. If this email already belongs to an existing user, the role is simply added to their account — no new credentials are issued.</span>
        }
      </div>
    </div>

    <div class="form-container">
      @if(formMeta && formFields) {
      <app-dynamic-forms-v2
        [formMetaData]="formMeta"
        [formFields]="formFields"
        [resetOnSubmit]="false"
        (formSubmitted)="onSubmit($event)">
      </app-dynamic-forms-v2>
      }
    </div>

    <div class="action-buttons">
      <button mat-stroked-button (click)="cancel()">
        Cancel
      </button>
    </div>
  </mat-card-content>
</mat-card>